module.exports = __webpack_public_path__ + "img/Accessories.6e89e44e.png";